<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="search">
            <form action="search-results.html" method="get" style="align-items: flex-start;">
              <label style="width: 75px;height: 150%;font-size: large;">Attachment</label>
              <img src="data:image/jpg;base64,{{myimage}}"  alt="User Image" width="1050px" height="1250px" style="border: 1px;border-style: inset;"/>
            </form>
            </div>
        </div>
    </div>
  </section>


  </mat-dialog-content>





